<template>
	<div
		v-if="anchorLink"
		:href="'#' + anchorLink.href"
		@click="scroll"
		class="link-container"
	>
		<BannerPromoTipContent :content="content" />
	</div>
	<LinkWrap
		v-else-if="link"
		v-bind="link"
		customType="div"
		class="link-container"
	>
		<BannerPromoTipContent :content="content" />
	</LinkWrap>
</template>

<script>
import LinkViewModel from "../../../../helpers/ViewModels/LinkViewModel.js";
import AnchorViewModel from "../../../../helpers/ViewModels/AnchorViewModel.js";

export default defineNuxtComponent({
	name: "BannerPromoTip",

  props: {
    content: {
      type: Object,
      required: true,
    }
  },

	computed: {
		link() {
			return this.content.link && LinkViewModel(this.content.link);
		},
		anchorLink() {
			return this.content.anchorLink && this.content.anchorLink.anchorText && AnchorViewModel(this.content.anchorLink);
		},
	},
});
</script>

<style lang="scss" scoped>
.link-container {
	width: 100%;
	height: 100%;

	&:hover {
		cursor: pointer;
	}
}
</style>
